import React, { useEffect, useState, useRef, useCallback } from 'react';
import Layout from '../../Components/Layout'
import { useLocation, useNavigate, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { FaStar } from "react-icons/fa";
import GoogleMapsLoader from '../../Components/Autocomplete/GoogleMapsLoader';
import "react-range-slider-input/dist/style.css";
import RangeSlider from "react-range-slider-input";
import config from '../../config';
import { FaMapMarkerAlt, FaHotel, FaBed } from "react-icons/fa";
import { MdOutlineLocalAirport } from "react-icons/md";
import Select from "react-dropdown-select";
import { FaInfoCircle } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
import ListCard from '../../Components/Hotel/ListCard';
import Swal from 'sweetalert2';
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";

// Servis importları
import hotelService from '../../services/hotelService';
import geoService from '../../services/geoService';
import accommodationService from '../../services/accommodationService';
import chainService from '../../services/chainService';

// Yardımcı fonksiyonlar
// Dereceyi radyana çeviren yardımcı fonksiyon
function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

export default function List() {

   // Hooks
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const counterRef = useRef(null);
    const { occupancies, start_date, end_date } = location.state || {};

    // Sabit değişkenler
    const apiKey = "AIzaSyB-KEQdcQ1sJvO1_OIhwk1vo6AzOyuolPs";
    const step = 10;
    const placeName = localStorage.getItem("place_name");
    const placeLat = parseFloat(localStorage.getItem("lat"));
    const placeLng = parseFloat(localStorage.getItem("lng"));
    const userData = JSON.parse(localStorage.getItem('user_data'));

    // Icon helper
    const getIcon = (type) => {
        if (type === "locality") return <FaMapMarkerAlt />;
        if (type === "hotel") return <FaHotel />;
        if (type === "lodging") return <FaBed />;
        if (type === "airport") return <MdOutlineLocalAirport />;
        return <FaMapMarkerAlt />; // Varsayılan ikon
    };

    const [chains, setChains] = useState([]);
    const [chainLess, setChainLess] = useState(true);
    const [selectedChain, setSelectedChain] = useState({
        code: "",
        name: "",
    });
    // State tanımlamaları
    const [selectedRate, setSelectedRate] = useState(null);
    const [markupValue, setMarkupValue] = useState(0);
    const [firstHotel, setFirstHotel] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [isSuggestLoading, setIsSuggestLoading] = useState(false);
    const [inputValue, setInputValue] = useState(searchParams.get('locationName') ?? '');
    const [selectedOption, setSelectedOption] = useState({ label: 'Default' });
    const [dragComplete, setDragComplete] = useState(false);
    const [prices, setPrices] = useState({
        min_price: searchParams.get('minPrice') ?? 100,
        max_price: searchParams.get('maxPrice') ?? 5000,
    });
    const [selectedStar, setSelectedStar] = useState(searchParams.get('star') ?? null);
    const [selectedBoards, setSelectedBoards] = useState(
        searchParams.get('boards') ? searchParams.get('boards').split(',') : []
    );
    const [selectedAccommodations, setSelectedAccommodations] = useState(
        searchParams.get('accTypes') ? searchParams.get('accTypes').split(',') : []
    );
    const [startDate, setStartDate] = useState(searchParams.get('checkIn') ?? null);
    const [endDate, setEndDate] = useState(searchParams.get('checkOut') ?? null);
    const [nation, setNation] = useState(searchParams.get('nation') ?? '');
    const [rooms, setRooms] = useState([]);
    const [Hotels, setHotels] = useState([]); // HotelList yerine Hotels ve setHotels olarak değiştirildi
    const [loading, setLoading] = useState(true);
    const [hotelCodes, setHotelCodes] = useState([]);
    const [sortedHotelData, setSortedHotelData] = useState([]);
    const [moreStatu, setMoreStatu] = useState(false);
    const [moreButtonStatu, setMoreButtonStatu] = useState(false);
    const [moreCounter, setMoreCounter] = useState(1);
    const [personalModal, setPersonalModal] = useState(false);
    const [countries, setCountries] = useState([]);
    const [roomCounter, setRoomCounter] = useState(1);
    const [adultCounter, setAdultCounter] = useState(2);
    const [childCounter, setChildCounter] = useState(0);
    const [child1Counter, setChild1Counter] = useState(0);
    const [child2Counter, setChild2Counter] = useState(0);
    const [totalCounter, setTotalCounter] = useState(adultCounter + childCounter);
    const [selectedPlace, setSelectedPlace] = useState(null);
    
    const [isLodging, setIsLodging] = useState(false);
    const [accommodation, setAccommodations] = useState([]);
    const [accommodationLess, setAccommodationLess] = useState(1);
    const [popularLocationLess, setPopularLocationLess] = useState(1);
    const [neighborhoodLess, setNeighborhoodLess] = useState(1);

    const isInitialMount = useRef(true);

    // URL parametrelerini ve First.jsx'ten gelen parametreleri yönetmek için useEffect
    useEffect(() => {
        const initializePage = async () => {
            // URL'den parametreleri al
            const urlParams = {
                checkIn: searchParams.get('checkIn'),
                checkOut: searchParams.get('checkOut'),
                nation: searchParams.get('nation'),
                lat: searchParams.get('lat'),
                lng: searchParams.get('lng'),
                locationName: searchParams.get('locationName'),
                hotelbedsCode: searchParams.get('hotelbedsCode'),
                occupanciesStr: searchParams.get('occupancies'),
                minPrice: searchParams.get('minPrice'),
                maxPrice: searchParams.get('maxPrice'),
                star: searchParams.get('star'),
                boards: searchParams.get('boards'),
                accTypes: searchParams.get('accTypes'),
                sort: searchParams.get('sort')
            };

            console.log('urlParams: ', urlParams);

            // State'leri güncelle
            if (urlParams.checkIn) {
                setStartDate(urlParams.checkIn);
                localStorage.setItem('start_date', urlParams.checkIn);
            }
            if (urlParams.checkOut) {
                setEndDate(urlParams.checkOut);
                localStorage.setItem('end_date', urlParams.checkOut);
            }
            if (urlParams.nation) {
                setNation(urlParams.nation);
            }
            if (urlParams.lat && urlParams.lng) {
                localStorage.setItem('lat', urlParams.lat);
                localStorage.setItem('lng', urlParams.lng);
            }
            if (urlParams.locationName) {
                setInputValue(urlParams.locationName);
                localStorage.setItem('place_name', urlParams.locationName);
            }
            if (urlParams.occupanciesStr) {
                console.log('occupanciesStr: ', urlParams.occupanciesStr);

                try {
                    // URL'den gelen occupancies parametresini decode et
                    const decodedOccupancies = decodeURIComponent(urlParams.occupanciesStr);
                    const occupanciesData = JSON.parse(decodedOccupancies);
                    console.log('occupanciesData: ', occupanciesData);
                    console.log('room1: ',rooms);
                    // Rooms state'ini güncelle
                    setRooms(occupanciesData.map((occ, index) => ({
                        id: index + 1,
                        adultCounter: occ.adults,
                        childCounter: occ.children,
                        childrenAges: occ.paxes?.map(pax => ({
                            type: "CH",
                            age: pax.age
                        })) || []
                    })));
                    console.log('room2: ',rooms);

                } catch (error) {
                    console.error("Error parsing occupancies:", error);
                    // Hata durumunda varsayılan değerleri kullan
                    setRooms([{
                        id: 1,
                        adultCounter: 2,
                        childCounter: 0,
                        childrenAges: []
                    }]);
                }
            } else {
                // Occupancies parametresi yoksa varsayılan değerleri kullan
                setRooms([{
                    id: 1,
                    adultCounter: 2,
                    childCounter: 0,
                    childrenAges: []
                }]);
            }

            // Filtre parametrelerini güncelle
            if (urlParams.minPrice || urlParams.maxPrice) {
                setPrices({
                    min_price: urlParams.minPrice ?? 100,
                    max_price: urlParams.maxPrice ?? 5000
                });
            }
            if (urlParams.star) {
                setSelectedStar(parseInt(urlParams.star));
            }
            if (urlParams.boards) {
                setSelectedBoards(urlParams.boards.split(','));
            }
            if (urlParams.accTypes) {
                setSelectedAccommodations(urlParams.accTypes.split(','));
            }
            if (urlParams.sort) {
                setSelectedOption({ id: urlParams.sort, label: getSortLabel(urlParams.sort) });
            }

            // İlk otel aramasını yap
            await fetchHotels();
        };

        initializePage();
    }, [searchParams]); // Sadece searchParams değiştiğinde çalışsın

    // Sort label helper function
    const getSortLabel = (sortId) => {
        switch (sortId) {
            case 'price_asc': return 'Price: low to high';
            case 'price_desc': return 'Price: high to low';
            case 'name_asc': return 'Name A-Z';
            case 'name_desc': return 'Name Z-A';
            default: return 'Default';
        }
    };

    // URL'i filtrelerle güncelleme fonksiyonu
    const updateUrlWithFilters = () => {
        const newParams = new URLSearchParams(searchParams);

        // Mevcut temel parametreleri koru
        const basicParams = ['checkIn', 'checkOut', 'nation', 'lat', 'lng', 'locationName', 'hotelbedsCode', 'occupancies'];
        basicParams.forEach(param => {
            if (searchParams.has(param)) {
                newParams.set(param, searchParams.get(param));
            }
        });

        // Fiyat filtresi
        if (prices.min_price !== 100 || prices.max_price !== 5000) {
            newParams.set('minPrice', prices.min_price.toString());
            newParams.set('maxPrice', prices.max_price.toString());
        } else {
            newParams.delete('minPrice');
            newParams.delete('maxPrice');
        }

        // Yıldız filtresi
        if (selectedStar) {
            newParams.set('star', selectedStar.toString());
        } else {
            newParams.delete('star');
        }

        // Board filtresi
        if (selectedBoards.length > 0) {
            newParams.set('boards', selectedBoards.join(','));
        } else {
            newParams.delete('boards');
        }

        // Accommodation filtresi
        if (selectedAccommodations.length > 0) {
            newParams.set('accTypes', selectedAccommodations.join(','));
        } else {
            newParams.delete('accTypes');
        }

        // Sıralama
        if (selectedOption.id !== 'recommend') {
            newParams.set('sort', selectedOption.id);
        } else {
            newParams.delete('sort');
        }

        // URL'i güncelle
        setSearchParams(newParams);
    };

    // Filtre değişikliklerini dinle ve URL'i güncelle
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }

        const newParams = new URLSearchParams(searchParams);
        
        // Filtre değerlerini URL'e ekle
        if (selectedStar) {
            newParams.set('star', selectedStar.toString());
        } else {
            newParams.delete('star');
        }

        if (selectedBoards.length > 0) {
            newParams.set('boards', selectedBoards.join(','));
        } else {
            newParams.delete('boards');
        }

        if (selectedAccommodations.length > 0) {
            newParams.set('accTypes', selectedAccommodations.join(','));
        } else {
            newParams.delete('accTypes');
        }

        // URL'i güncelle ve otelleri yeniden getir
        setSearchParams(newParams);
        
        fetchHotels();
    }, [selectedBoards, selectedAccommodations, selectedStar, prices.min_price, prices.max_price, selectedOption]);
 

    // Event handlers
    const handleChildAgeChange = (roomId, index, value) => {
        setRooms((prevRooms) =>
            prevRooms.map((room) => {
                if (room.id === roomId) {
                    const updatedAges = [...room.childrenAges];
                    updatedAges[index] = { age: Number(value) };
                    return { ...room, childrenAges: updatedAges };
                }
                return room;
            })
        );
    };

    const updateRoomCount = (counterType) => {
        setRooms((prevRooms) => {
            if (counterType === "increment") {
                return [
                    ...prevRooms,
                    {
                        id: prevRooms.length + 1,
                        adultCounter: 2,
                        childCounter: 0,
                        childrenAges: [],
                    },
                ];
            } else if (counterType === "decrement" && prevRooms.length > 1) {
                return prevRooms.slice(0, -1);
            }
            return prevRooms;
        });
    };

    const handleStarClick = (star) => {
        setSelectedStar(star);
    };

    const updateRoomCounters = (roomId, type, counterType) => {
        setRooms((prevRooms) =>
            prevRooms.map((room) => {
                if (room.id === roomId) {
                    if (type === "adult") {
                        return {
                            ...room,
                            adultCounter:
                                counterType === "increment"
                                    ? room.adultCounter + 1
                                    : Math.max(1, room.adultCounter - 1),
                        };
                    } else if (type === "child") {
                        const newChildCounter =
                            counterType === "increment"
                                ? room.childCounter + 1
                                : Math.max(0, room.childCounter - 1);

                        const validChildCounter = Math.max(0, newChildCounter);

                        return {
                            ...room,
                            childCounter: validChildCounter,
                            childrenAges: validChildCounter < room.childrenAges.length
                                ? room.childrenAges.slice(0, validChildCounter)
                                : [
                                    ...room.childrenAges,
                                    ...Array(validChildCounter - room.childrenAges.length).fill({ type: 'CH', age: "" }),
                                ],
                        };
                    }
                }
                return room;
            })
        );
    };

    const handlePlaceSelected = (place) => {
        setSelectedPlace({
            name: place.name,
            lat: place.lat,
            lng: place.lng,
        });
        localStorage.setItem("place_name", place.name);
        localStorage.setItem("lat", place.lat);
        localStorage.setItem("lng", place.lng);
    };

    const handleBoardChange = (code) => {
        setSelectedBoards((prevCodes) => {
            if (prevCodes.includes(code)) {
                return prevCodes.filter((item) => item !== code);
            } else {
                return [...prevCodes, code];
            }
        });
    };

    const handleNeighborhoodChange = (name) => {
        const selected = neighborhoods.find((item) => item.name === name);
        if (selected) {
            setSelectedNeighborhood({
                name: selected.name,
                lat: selected.lat,
                lng: selected.lng,
            });
            setSelectedLocation({
                name: selected.name,
                latitude: selected.lat,
                longitude: selected.lng,
                hotelbeds_code: null,
                formatted_address: null,
            })
            setSelectedPopularLocation({
                name: null,
                lat: null,
                lng: null,
            });
            setInputValue(selected.name)
            fetchHotels(selected.name, selected.lat, selected.lng);
        }
    };

    const handlePopularLocationChange = (name) => {
        const selected = popularLocations.find((item) => item.name === name);
        if (selected) {
            setSelectedPopularLocation({
                name: selected.name,
                lat: selected.lat,
                lng: selected.lng,
            });
            setInputValue(selected.name);
            setSelectedNeighborhood({
                name: null,
                lat: null,
                lng: null,
            });

            // En yakın mahalleyi bul (maksimum 5 km içinde)
            let nearestNeighborhood = null;
            let minDistance = Infinity;

            neighborhoods.forEach((neighborhood) => {
                const distance = calculateDistance(
                    selected.lat,
                    selected.lng,
                    neighborhood.lat,
                    neighborhood.lng
                );
                if (distance < 5 && distance < minDistance) {
                    minDistance = distance;
                    nearestNeighborhood = neighborhood;
                }
            });

            if (nearestNeighborhood) {
                setSelectedNeighborhood({
                    name: nearestNeighborhood.name,
                    lat: nearestNeighborhood.lat,
                    lng: nearestNeighborhood.lng,
                });

                setSelectedLocation({
                    name: nearestNeighborhood.name,
                    latitude: nearestNeighborhood.lat,
                    longitude: nearestNeighborhood.lng,
                    hotelbeds_code: null,
                    formatted_address: null,
                });
                fetchHotels(nearestNeighborhood.name, nearestNeighborhood.lat, nearestNeighborhood.lng);
            } else {
                console.warn("Yakınlarda mahalle bulunamadı.");
            }

            setSelectedPlace({
                name: selected.name,
                lat: selected.lat,
                lng: selected.lng,
                hotelbeds_code: null,
                formatted_address: null,
            });

            fetchHotels(selected.name, selected.lat, selected.lng);
        }
    };

    const handleAccomChange = (code) => {
        setSelectedAccommodations((prev) => {
            if (prev.includes(code)) {
                return prev.filter((item) => item !== code);
            } else {
                return [...prev, code];
            }
        });
    };

    const calculateDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371;
        const dLat = deg2rad(lat2 - lat1);
        const dLng = deg2rad(lng2 - lng1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    const handleCounterChange = (type, field) => {
        if (field === "adult") {
            setAdultCounter((prev) => {
                if (type === "increment") {
                    setTotalCounter(adultCounter + child1Counter + child2Counter + 1);
                    return prev + 1;
                } else if (type === "decrement") {
                    if (prev > 1) {
                        setTotalCounter(adultCounter + child1Counter + child2Counter - 1);
                        return prev - 1;
                    } else {
                        return 1;
                    }
                }
                return prev;
            });
        }
    };

    const handleCheckboxChange = (event) => {
        const { id, nextElementSibling: { textContent } } = event.target;
        setSelectedOption({ id, label: textContent });
    };
    const handleRangeChange = (values) => {
        setPrices({
            min_price: values[0],
            max_price: values[1],
        });
    };
    const handleDragEnd = () => {
        setDragComplete(true);
        console.log("Fiyatlar güncellendi:", prices);

        setTimeout(() => {
            setDragComplete(false);
        }, 100);
    };
    const [selectedPopularLocation, setSelectedPopularLocation] = useState({
        name: "",
        lat: null,
        lng: null,
    });
    const [selectedLocation, setSelectedLocation] = useState({
        name: location.state?.selectedLocation?.name ?? null,
        latitude: location.state?.selectedLocation?.latitude ?? null,
        longitude: location.state?.selectedLocation?.longitude ?? null,
        hotelbeds_code: location.state?.selectedLocation?.hotelbeds_code ?? null,
        formatted_address: location.state?.selectedLocation?.formatted_address ?? null,
    });
    const [selectedNeighborhood, setSelectedNeighborhood] = useState({
        name: "",
        lat: null,
        lng: null,
    });
    // Benzerlik skoru hesaplayan fonksiyon
    function getSimilarityScore(str1, str2) {
        const longer = str1.length > str2.length ? str1 : str2;
        const shorter = str1.length > str2.length ? str2 : str1;

        const longerLength = longer.length;
        if (longerLength === 0) {
            return 1.0; // İki boş string aynı kabul edilir
        }
        return (longerLength - getEditDistance(longer, shorter)) / parseFloat(longerLength);
    }
    // Edit distance hesaplayan fonksiyon (Levenshtein distance)
    function getEditDistance(str1, str2) {
        const tmp = [];
        let i, j,
            l1 = str1.length,
            l2 = str2.length,
            al = l1 + 1,
            bl = l2 + 1;

        for (i = 0; i < al; i++) tmp[i] = [i];
        for (j = 0; j < bl; j++) tmp[0][j] = j;

        for (i = 1; i < al; i++) {
            for (j = 1; j < bl; j++) {
                tmp[i][j] =
                    str1[i - 1] === str2[j - 1]
                        ? tmp[i - 1][j - 1]
                        : Math.min(
                            tmp[i - 1][j - 1] + 1,
                            Math.min(tmp[i][j - 1] + 1, tmp[i - 1][j] + 1)
                        );
            }
        }
        return tmp[l1][l2];
    }
    function findHotelsByDistanceAndSimilarity(placeLat, placeLng, hotelData) {
        const SIMILARITY_THRESHOLD = 0.65; // %80 benzerlik eşiği
        const hotelsWithDistance = hotelData.map((hotel) => {
            const distance = calculateDistance(
                placeLat,
                placeLng,
                parseFloat(hotel.latitude),
                parseFloat(hotel.longitude)
            );
            const similarityScore = getSimilarityScore(
                placeName.toLowerCase(),
                hotel.name.toLowerCase()
            );
            const isSimilar = similarityScore >= SIMILARITY_THRESHOLD;
            return { ...hotel, distance, isSimilar, similarityScore }; // Mesafe ve benzerlik skorunu otel verisine ekle
        });
        hotelsWithDistance.sort((a, b) => a.distance - b.distance);

        return hotelsWithDistance;
    }
    const sortHotelsByOption = (hotelData, selectedOption) => {
        switch (selectedOption.id) { // selectedOption.id'yi kullanarak kontrol et
            case 'price_asc':
                return hotelData.sort((a, b) => parseFloat(a.minRate) - parseFloat(b.minRate)); // Fiyatı artan sıraya göre sırala
            case 'price_desc':
                return hotelData.sort((a, b) => parseFloat(b.minRate) - parseFloat(a.minRate)); // Fiyatı azalan sıraya göre sırala
            case 'name_asc':
                return hotelData.sort((a, b) => a.name.localeCompare(b.name)); // İsimleri A-Z sıralayacak
            case 'name_desc':
                return hotelData.sort((a, b) => b.name.localeCompare(a.name)); // İsimleri Z-A sıralayacak
            case 'recommend': // Eğer 'recommend' seçili ise, hiçbir sıralama yapma, mevcut sırayı koru
            default:
                return hotelData;
        }
    };


    const fetchFirstHotel = async () => {
        const hotelbedsCode = location.state?.selectedLocation?.hotelbeds_code;
        if (!hotelbedsCode) {
            console.log("Hotelbeds code is not available.");
            return;
        }
        
        const requestData = {
            hotels: { hotel: [hotelbedsCode] },
            stay: {
                checkIn: startDate ?? localStorage.getItem("start_date"),
                checkOut: endDate ?? localStorage.getItem("end_date"),
            },
            occupancies: occupancies ?? [{ rooms: 1, adults: 2, children: 0 }],
            filters: {
                maxRooms: 2,
                maxRatesPerRoom: 1,
            },
            language: "ENG",
            sourceMarket: localStorage.getItem("nation") ?? "TR",
        };
        
        try {
            // Servis katmanını kullanarak otel detaylarını getir
            const secondHotelData = await hotelService.getHotelWithCode(requestData);
            
            // Servis katmanını kullanarak küçük otel verilerini getir
            const smallHotelData = await hotelService.getSmallData(
                [hotelbedsCode],
                {
                    stay: {
                        checkIn: startDate ?? localStorage.getItem("start_date"),
                        checkOut: endDate ?? localStorage.getItem("end_date")
                    },
                    occupancies: [{
                        rooms: 1,
                        adults: 2,
                        children: 0,
                        paxes: []
                    }],
                    language: "ENG",
                    sourceMarket: localStorage.getItem("nation") ?? "ENG"
                }
            );

            // İki veri setini birleştir
            const mergedHotels = secondHotelData.map(hotel => {
                const matchingHotel = smallHotelData.find(smallHotel => smallHotel.code === hotel.code);

                return {
                    ...hotel,
                    ...(matchingHotel || {}), // Eşleşen otel bilgilerini ekle
                };
            });
            
            // Filter first hotel by selected chain if a chain is selected
            const filteredHotels = selectedChain.code 
                ? mergedHotels.filter(hotel => {
                    // Log the entire hotel object to see its structure
                    console.log(`First Hotel ${hotel.name} full object:`, hotel);
                    
                    const hasMatchingChain = hotel.chain && hotel.chain.code === selectedChain.code;
                    console.log(`First Hotel ${hotel.name} (${hotel.code}) chain: ${hotel.chain?.code}, selected chain: ${selectedChain.code}, match: ${hasMatchingChain}`);
                        return hasMatchingChain;
                }) 
            : mergedHotels;

            setFirstHotel(filteredHotels);
            console.log("Merged Hotels:", mergedHotels, ' firstHotel: ', firstHotel);
        } catch (error) {
            console.error("Error fetching hotel data: ", error);
        }
    };

    const fetchHotels = useCallback(async () => {
        try {
            setLoading(true);
            setHotels([]);
            setHotelCodes([]);

            // API isteği için parametreleri hazırla
            const requestData = {
                filters: {
                    maxRooms: 10,
                    maxRatesPerRoom: 1,
                    minRate: searchParams.get('minPrice') ?? prices.min_price ?? 100,
                    maxRate: searchParams.get('maxPrice') ?? prices.max_price ?? 5000,
                    minCategory: searchParams.get('star') ?? selectedStar ?? 1,
                    maxCategory: searchParams.get('star') ?? selectedStar ?? 5,
                },
                accommodations: searchParams.get('accTypes')?.split(',') ?? selectedAccommodations ?? [],
                boards: searchParams.get('boards')?.split(',') ?? selectedBoards ?? [],
                sourceMarket: localStorage.getItem("nation") ?? "ENG",
                language: "ENG",
                stay: {
                    checkIn: searchParams.get('checkIn') ?? startDate ?? localStorage.getItem("start_date"),
                    checkOut: searchParams.get('checkOut') ?? endDate ?? localStorage.getItem("end_date"),
                },
                occupancies: searchParams.get('occupancies') ? JSON.parse(searchParams.get('occupancies')) : 
                            rooms.map(room => ({
                                rooms: 1,
                                adults: room.adultCounter,
                                children: room.childCounter,
                                paxes: room.childrenAges.map(child => ({
                                    type: "CH",
                                    age: child.age || ""
                                }))
                            })),
                geolocation: {
                    latitude: searchParams.get('lat') ?? localStorage.getItem("lat"),
                    longitude: searchParams.get('lng') ?? localStorage.getItem("lng"),
                    radius: 3,
                    unit: "km",
                },
            };

            // Servis katmanını kullanarak otelleri getir
            const hotelData = await hotelService.getHotels(requestData);

            // Otelleri sırala
            const sortedHotels = findHotelsByDistanceAndSimilarity(
                parseFloat(localStorage.getItem("lat")),
                parseFloat(localStorage.getItem("lng")),
                hotelData
            );
            console.log('sortedHotels: ', sortedHotels)
            const finalSortedHotels = sortHotelsByOption(sortedHotels, selectedOption);
            const hotelCodes = finalSortedHotels.map(hotel => hotel.code);

            setHotelCodes(hotelCodes);
            setSortedHotelData(finalSortedHotels);

            // İlk 10 otel için detaylı veri çek
            const firstTenCodes = hotelCodes.slice(0, 10);
            setMoreButtonStatu(hotelCodes.length > 10);

            if (firstTenCodes.length > 0) {
                // Servis katmanını kullanarak küçük otel verilerini getir
                const secondHotelData = await hotelService.getSmallData(
                    firstTenCodes,
                    {
                        stay: {
                            checkIn: startDate ?? localStorage.getItem("start_date"),
                            checkOut: endDate ?? localStorage.getItem("end_date")
                        },
                        occupancies: [{
                            rooms: 1,
                            adults: 2,
                            children: 0,
                            paxes: []
                        }],
                        language: "ENG",
                        sourceMarket: localStorage.getItem("nation") ?? "ENG"
                    }
                );

                // Verileri birleştir
                const mergedHotels = secondHotelData.map(hotel => {
                    const matchingHotel = sortedHotels.find(h => h.code === hotel.code);
                    return {
                        ...hotel,
                        minRate: matchingHotel?.minRate || null,
                        maxRate: matchingHotel?.maxRate || null,
                        currency: matchingHotel?.currency || null,
                        slug: matchingHotel?.slug || null,
                        isSimilar: matchingHotel?.isSimilar || false,
                        similarityScore: matchingHotel?.similarityScore || null,
                        categoryCode: matchingHotel?.categoryCode || null,
                        rooms: matchingHotel?.rooms || null,
                    };
                });

                const filteredHotels = selectedChain.code 
                    ? mergedHotels.filter(hotel => {
                        // Log the entire hotel object to see its structure
                        console.log(`Hotel ${hotel.name} full object:`, hotel);
                        
                        // Check if the hotel has a chain property and if its code matches the selected chain code
                        const hasMatchingChain = hotel.chain && hotel.chain.code === selectedChain.code;
                        console.log(`Hotel ${hotel.name} (${hotel.code}) chain: ${JSON.stringify(hotel.chain)}, selected chain: ${selectedChain.code}, match: ${hasMatchingChain}`);
                        return hasMatchingChain;
                    }) 
                    : mergedHotels;
                setHotels(filteredHotels);
                console.log("filteredHotels:", filteredHotels);
            }
        } catch (error) {
            console.error("API isteği başarısız oldu:", error);
        } finally {
            setLoading(false);
        }
    }, [searchParams, startDate, endDate, nation, rooms, prices, selectedStar, selectedAccommodations, selectedBoards, selectedOption]);

    useEffect(() => {
        const storedLat = parseFloat(localStorage.getItem("lat"));
        const storedLng = parseFloat(localStorage.getItem("lng"));

        if (!storedLat || !storedLng) return;

        const closestNeighborhood = neighborhoods.reduce((closest, current) => {
            const currentDistance = calculateDistance(
                storedLat,
                storedLng,
                current.lat,
                current.lng
            );
            const closestDistance = calculateDistance(
                storedLat,
                storedLng,
                closest.lat,
                closest.lng
            );
            return currentDistance < closestDistance ? current : closest;
        }, neighborhoods[0]);

        const distanceToClosest = calculateDistance(
            storedLat,
            storedLng,
            closestNeighborhood.lat,
            closestNeighborhood.lng
        );

        if (distanceToClosest <= 3) {
            setSelectedNeighborhood({
                name: closestNeighborhood.name,
                lat: closestNeighborhood.lat,
                lng: closestNeighborhood.lng,
            });
        } else {
            setSelectedNeighborhood({ name: "", lat: null, lng: null }); // Null yerine boş değerler
        }
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Servis katmanını kullanarak ülkeleri getir
                const countriesData = await geoService.getCountries();
                setCountries(countriesData);
                
                // Servis katmanını kullanarak konaklama türlerini getir
                const accommodationsData = await accommodationService.getAccommodations();
                setAccommodations(accommodationsData);
                
                setSelectedPlace({
                    name: localStorage.getItem("place_name"),
                    lat: localStorage.getItem("lat"),
                    lng: localStorage.getItem("lng"),
                });
                
                if (start_date) {
                    setStartDate(start_date);
                    localStorage.setItem('start_date', start_date);
                } else {
                    setStartDate(localStorage.getItem('start_date'));
                }
                
                if (end_date) {
                    setEndDate(end_date);
                    localStorage.setItem('end_date', end_date);
                } else {
                    setEndDate(localStorage.getItem('end_date'));
                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        };
        
        fetchData();
    }, []);
    
    const handleChainChange = (code, name) => {
        if (selectedChain.code === code) {
            // If the same chain is clicked again, deselect it
            setSelectedChain({
                code: "",
                name: "",
            });
        } else {
            // Select the new chain
            setSelectedChain({
                code: code,
                name: name,
            });
        }
    };
    
    useEffect(() => {
        const fetchChainsData = async () => {
            try {
                // Servis katmanını kullanarak otel zincirlerini getir
                const chainsData = await chainService.getChains();
                setChains(chainsData);
            } catch (error) {
                console.error('Error fetching chains:', error);
            }
        };
        
        fetchChainsData();
        fetchHotels();
    }, []);
    useEffect(() => {
        fetchFirstHotel();
    }, [location.state?.selectedLocation?.hotelbeds_code]);

    useEffect(() => {
        fetchHotels();
    }, [selectedBoards, selectedAccommodations, dragComplete, selectedStar, selectedOption, selectedChain]);

    const fetchMoreHotels = async (currentCounter, hotelCodes, setHotels, setMoreStatu) => {
        console.log("Fetching more hotels, counter:", hotelCodes);
        try {
            const start = Math.min(currentCounter * step, hotelCodes.length);
            const end = Math.min((currentCounter + 1) * step, hotelCodes.length);
            const selectedCodes = hotelCodes.slice(start, end).filter((hotel) => typeof hotel === "number");

            if (selectedCodes.length === 0) {
                console.warn("No more valid hotel codes to fetch.");
                setMoreButtonStatu(false);
                return;
            }

            // Servis katmanını kullanarak küçük otel verilerini getir
            const secondHotelData = await hotelService.getSmallData(
                selectedCodes,
                {
                    stay: {
                        checkIn: startDate ?? localStorage.getItem("start_date"),
                        checkOut: endDate ?? localStorage.getItem("end_date")
                    },
                    occupancies: [{
                        rooms: 1,
                        adults: 2,
                        children: 0,
                        paxes: []
                    }],
                    language: "ENG",
                    sourceMarket: localStorage.getItem("nation") ?? "ENG"
                }
            );

            const mergedHotels = secondHotelData.map((hotel) => {
                const matchingHotel = sortedHotelData.find((h) => h.code === hotel.code);
                return {
                    ...hotel,
                    minRate: matchingHotel ? matchingHotel.minRate : null,
                    maxRate: matchingHotel ? matchingHotel.maxRate : null,
                    currency: matchingHotel ? matchingHotel.currency : null,
                    slug: matchingHotel ? matchingHotel.slug : null,
                    isSimilar: matchingHotel ? matchingHotel.isSimilar : false, // `isSimilar` özelliğini de ekle
                    similarityScore: matchingHotel ? matchingHotel.similarityScore : null, // Benzerlik skorunu da ekle
                    categoryCode: matchingHotel ? matchingHotel.categoryCode : null,
                    rooms: matchingHotel?.rooms || null,
                };
            });

            const filteredHotels = selectedChain.code 
                ? mergedHotels.filter(hotel => {
                    // Log the entire hotel object to see its structure
                    console.log(`More Hotel ${hotel.name} full object:`, hotel);
                    
                    // Check if the hotel has a chain property and if its code matches the selected chain code
                    const hasMatchingChain = hotel.chain && hotel.chain.code === selectedChain.code;
                    console.log(`More Hotel ${hotel.name} (${hotel.code}) chain: ${JSON.stringify(hotel.chain)}, selected chain: ${selectedChain.code}, match: ${hasMatchingChain}`);
                    return hasMatchingChain;
                }) 
                : mergedHotels;

            console.log("Selected Chain in fetchMoreHotels:", selectedChain);
            console.log("Filtered Hotels Count in fetchMoreHotels:", filteredHotels.length);
            console.log("Total Hotels Count in fetchMoreHotels:", mergedHotels.length);
            
            setHotels((prevHotelList) => [...prevHotelList, ...filteredHotels]);

        } catch (error) {
            console.error("Veri çekerken bir hata oluştu:", error);
        } finally {
            setMoreStatu(false);
        }
    };
    const handleLoadMore = () => {
        console.log("Load more clicked");
        if (moreCounter < Math.ceil(hotelCodes.length / step)) {
            setMoreStatu(true);
            setMoreCounter((prevCounter) => {
                const newCounter = prevCounter + 1;
                console.log("New Counter:", newCounter);
                fetchMoreHotels(newCounter, hotelCodes, setHotels, setMoreStatu);
                return newCounter;
            });
        } else {
            console.log("All hotels loaded");
        }
    };
    const getMarkers = (Hotels) => {
        return Hotels.map((hotel, index) => ({
            id: index + 1, // ID'leri 1'den başlatıyoruz
            lat: hotel.coordinates.latitude,
            lng: hotel.coordinates.longitude,
            info: hotel.name, // Info için otel adı kullanılıyor
        }));
    };
    const markers = getMarkers(Hotels);
    const handleViewDetails = async (hotel) => {
        // Rooms state'inden occupancies bilgisini oluştur
        const currentOccupancies = rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
        }));

        const formData = {
            code: hotel.code,
            stay: {
                checkIn: startDate,
                checkOut: endDate
            },
            occupancies: currentOccupancies,
            start_date: startDate,
            end_date: endDate
        };
        if (selectedBoards && selectedBoards.length > 0) {
            formData.boards = {
                included: true,
                board: selectedBoards
            };
        }
        console.log('formData: ', formData)
        localStorage.setItem('hotel_code', hotel.code);
        localStorage.setItem('hotel_slug', hotel.slug);
        // Her occupancy için room, adults, children değerlerini alıp virgülle ayırıyoruz.
        const roomsParam = currentOccupancies.map(occ => occ.rooms).join(',') || '1';
        const adultsParam = currentOccupancies.map(occ => occ.adults).join(',') || '1';
        const childrenParam = currentOccupancies.map(occ => occ.children).join(',') || '0';

        // Her occupancy için paxes içerisindeki age değerlerini tire ile birleştirip, 
        // tüm occupancy'ler arasına pipe işareti ekliyoruz.
        const agesParam = currentOccupancies
            .map(occ => occ.paxes?.map(p => p.age).join('-'))
            .join('|') || '';

        // Nationality bilgisi için ISO kodu kullan
        const nationalityParam = localStorage.getItem("nation") || 'TR';

        const url = `/hotel-detail/${hotel.code}/${hotel.slug}?checkIn=${startDate}&checkOut=${endDate}&rooms=${roomsParam}&adults=${adultsParam}&children=${childrenParam}&ages=${agesParam}&nationality=${nationalityParam}`;

        navigate(url);
        window.scrollTo(0, 0);
    };

    const StaticGoogleMap = ({ apiKey, markers }) => {
        const baseUrl = "https://maps.googleapis.com/maps/api/staticmap";
        const mapSize = "600x200"; // Görüntü boyutu: genişlik x yükseklik
        const zoom = 15;

        // Markerları oluşturmak için URL stringi
        const markerParams = markers
            .map(marker => `markers=color:red%7Clabel:%7C${marker.lat},${marker.lng}`)
            .join("&");

        // Statik harita URL'sini oluştur
        const mapUrl = `${baseUrl}?size=${mapSize}&zoom=${zoom}&${markerParams}&key=${apiKey}`;

        return (
            <div style={{ height: "200px", width: "100%" }}>
                <img src={mapUrl} alt="Static Google Map" style={{ width: "100%", height: "100%", objectFit: 'cover' }} />
            </div>
        );
    };
    const handleSubmitForm = async (e) => {
        e.preventDefault();

        if (!selectedPlace) {
            Swal.fire({
                title: "Please select the destination!",
                icon: "info",
                draggable: true,
            });
            return;
        }

        if (!nation) {
            Swal.fire({
                title: "Please select the nationality!",
                icon: "info",
                draggable: true,
            });
            return;
        }

        // URL parametrelerini güncelle
        const params = new URLSearchParams();
        
        // Temel parametreleri ekle
        params.set('checkIn', startDate);
        params.set('checkOut', endDate);
        params.set('nation', nation);
        params.set('lat', selectedPlace.lat);
        params.set('lng', selectedPlace.lng);
        params.set('locationName', selectedPlace.name);

        // Konum bilgilerini ekle
        if (selectedLocation.hotelbeds_code) {
            params.set('hotelbedsCode', selectedLocation.hotelbeds_code);
        }

        // Occupancies bilgisini ekle
        const occupancies = rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
        }));
        params.set('occupancies', JSON.stringify(occupancies));

        // Mevcut filtreleri de ekle
        if (selectedStar) params.set('star', selectedStar.toString());
        if (selectedBoards.length > 0) params.set('boards', selectedBoards.join(','));
        if (selectedAccommodations.length > 0) params.set('accTypes', selectedAccommodations.join(','));
        if (prices.min_price !== 100) params.set('minPrice', prices.min_price.toString());
        if (prices.max_price !== 5000) params.set('maxPrice', prices.max_price.toString());
        if (selectedOption.id !== 'recommend') params.set('sort', selectedOption.id);

        // URL'i güncelle
        setSearchParams(params);

        // Seçili otel varsa firstHotel'i temizle
        if (selectedLocation.hotelbeds_code == null) {
            setFirstHotel([]);
        }

        // Yeni parametrelerle otelleri getir
        await fetchHotels();
    };

    useEffect(() => {
        const storedNationIso2 = localStorage.getItem("nation");
        if (storedNationIso2) {
            const matchedCountry = countries.find(
                (country) => country.iso2 === storedNationIso2
            );
            if (matchedCountry) {
                setNation(matchedCountry.name);
            }
        }
    }, [countries]);
    const handleChange = (selected) => {
        if (selected.length > 0) {
            setNation(selected[0].name);
            localStorage.setItem("nation", selected[0].iso2);
        } else {
            setNation(""); // Seçim kaldırıldığında state'i sıfırla
            localStorage.removeItem("nation"); // LocalStorage'dan nation bilgisini kaldır
        }
    };
    const fetchSuggestions = async (searchText) => {
        setIsSuggestLoading(true);
        try {
            // Servis katmanını kullanarak otomatik tamamlama önerilerini getir
            const suggestions = await geoService.getAutoComplete(searchText);
            setSuggestions(suggestions.slice(0, 10)); // İlk 10 sonucu al
            console.log("suggestion: ", suggestions);
        } catch (error) {
            console.error("Error fetching suggestions:", error);
            setSuggestions([]);
        } finally {
            setIsSuggestLoading(false);
        }
    };
    const handleSuggestInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        // Eğer kullanıcı bir şey yazmazsa önerileri temizle
        if (value.length < 3) {
            setSuggestions([]);
            return;
        }

        // Önceki timeout'u temizle
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        // Yeni bir timeout başlat
        debounceTimeout.current = setTimeout(() => {
            fetchSuggestions(value);
        }, 500); // 1 saniye bekle
    };
    const handleSuggestionClick = (suggestion) => {

        setSelectedNeighborhood({
            name: null,
            lat: null,
            lng: null,
        });
        setSelectedPopularLocation({
            name: null,
            lat: null,
            lng: null,
        });
        setSelectedLocation({
            name: suggestion.name,
            latitude: suggestion.latitude,
            longitude: suggestion.longitude,
            hotelbeds_code: suggestion.hotelbeds_code || null, // hotelbeds_code yoksa boş bırak
            formatted_address: suggestion.formatted_address || null, // formatted_address yoksa boş bırak
        });
        setSelectedPlace({
            name: suggestion.name,
            lat: suggestion.latitude,
            lng: suggestion.longitude,
        });
        localStorage.setItem("place_name", suggestion.name);
        localStorage.setItem("lat", suggestion.latitude);
        localStorage.setItem("lng", suggestion.longitude);

        setInputValue(suggestion.name); // Input alanını seçilen isimle güncelle
        setSuggestions([]); // Dropdown'u kapat
    };
    const handleClickMap = () => {
        // URL parametrelerini oluştur
        const params = new URLSearchParams();
        
        // Temel parametreleri ekle
        params.set('checkIn', startDate);
        params.set('checkOut', endDate);
        params.set('nation', localStorage.getItem("nation") ?? "TR");
        params.set('lat', selectedPlace ? selectedPlace.lat : localStorage.getItem("lat"));
        params.set('lng', selectedPlace ? selectedPlace.lng : localStorage.getItem("lng"));
        
        // Konum bilgilerini ekle
        if (selectedLocation.hotelbeds_code) {
            params.set('hotelbedsCode', selectedLocation.hotelbeds_code);
        }
        params.set('locationName', selectedLocation.name || selectedPlace?.name || localStorage.getItem("place_name"));

        // Occupancies bilgisini ekle
        const occupancies = rooms.map(room => ({
            rooms: 1,
            adults: room.adultCounter,
            children: room.childCounter,
            paxes: room.childrenAges.map(child => ({
                type: "CH",
                age: child.age || ""
            }))
        }));
        params.set('occupancies', JSON.stringify(occupancies));

        // Harita görünümüne yönlendir
        navigate(`/hotels-with-map?${params.toString()}`);
        window.scrollTo(0, 0);
    };

    const handleBookSubmit = async (ratekey, hotel, room) => {
        const formData = {
            room: room,
            rate: ratekey,
            rateKey: ratekey.rateKey,
            hotel: hotel,
            start_date: location.state?.start_date ?? localStorage.getItem('start_date'),
            end_date: location.state?.end_date ?? localStorage.getItem('end_date'),
            adultCounter: adultCounter,
            childCounter: child2Counter
        }
        navigate(`/checkout`, { state: formData });
        window.scrollTo(0, 0);
    };

    const debounceTimeout = useRef(null);
    if (loading) {
        return (
            <div id="loader-wrapper">
                <div id="loader">
                    <span className="loader-line"></span>
                </div>
            </div>
        )
    }
    return (
        <Layout>
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">Hotels</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="index.html"><i className="isax isax-home5"></i></a></li>
                                    <li className="breadcrumb-item">Hotels</li>
                                    <li className="breadcrumb-item active" aria-current="page">Hotel Lists</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">

                    <div className="card">
                        <div className="card-body">
                            <div className="banner-form">
                                <form onSubmit={handleSubmitForm}>
                                    <div className="d-lg-flex">
                                        <div className="d-flex form-info">
                                            <div className="form-item dropdown">
                                                <div>
                                                    <label className="form-label fs-14 text-default mb-3">
                                                        Destination & Hotel
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter a place name"
                                                        value={inputValue ?? localStorage.getItem('place_name')}
                                                        onChange={handleSuggestInputChange}
                                                        className="form-control"
                                                    />
                                                    {isSuggestLoading && <div>Loading...</div>}
                                                    {suggestions.length > 0 && (
                                                        <ul style={{ width: "300px" }} className="dropdown-menu-custom">
                                                            {suggestions.map((suggestion, index) => (
                                                                <li
                                                                    key={index}
                                                                    onClick={() => handleSuggestionClick(suggestion)}
                                                                    className="dropdown-item-custom"
                                                                >
                                                                    {getIcon(suggestion.type)} {suggestion.name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-item d-flex flex-column">
                                                <label className="form-label fs-14 text-default mb-3">Check In</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    defaultValue={startDate}
                                                    min={new Date().toISOString().split('T')[0]}
                                                    onChange={(e) => {
                                                        const newStartDate = e.target.value;
                                                        setStartDate(newStartDate);
                                                        const nextDay = new Date(newStartDate);
                                                        nextDay.setDate(nextDay.getDate() + 1);
                                                        setEndDate(nextDay.toISOString().split('T')[0]);
                                                    }}
                                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                />

                                            </div>
                                            <div className="form-item">
                                                <label className="form-label fs-14 text-default mb-3">Check Out</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={endDate}
                                                    min={startDate}
                                                    max={startDate ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 90)).toISOString().split('T')[0] : ''}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                />
                                            </div>
                                            <div className="form-item dropdown">
                                                <div>
                                                    <label className="form-label fs-14 text-default mb-1">Guests</label>
                                                    <h5>
                                                        {rooms?.reduce((total, room) => total + room.adultCounter + room.childCounter, 0)}
                                                        <span className="fw-normal fs-14"> Persons</span>
                                                    </h5>

                                                    <p
                                                        onClick={() => setPersonalModal(!personalModal)}
                                                        style={{ cursor: "pointer", padding: "1%", color: "gray" }}
                                                    >
                                                        {rooms?.length} Room,{" "}
                                                        {rooms?.reduce((total, room) => total + room.adultCounter, 0)} Adult,{" "}
                                                        {rooms?.reduce((total, room) => total + room.childCounter, 0)} Children
                                                    </p>

                                                </div>
                                                <div
                                                    className="personality"
                                                    ref={counterRef}
                                                    style={{
                                                        display: personalModal ? "block" : "none",
                                                        width: "350px",
                                                        backgroundColor: "whitesmoke",
                                                        padding: "10px",
                                                        borderRadius: "4px",
                                                        border: "solid 1px lightgray",
                                                        position: "absolute",
                                                        zIndex: 9999, // Z-index ayarı ön planda tutar.
                                                        marginLeft: "-100px",
                                                        top: "100%", // Modal'ın aşağıda görünmesi için.
                                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                    }}
                                                >
                                                    <div className="d-flex flex-row" style={{ gap: "10px", paddingBlock: "20px" }}>
                                                        <div className="d-flex flex-row" style={{ gap: "10px", justifyContent: "space-between" }}>
                                                            <label htmlFor="">Room:</label>
                                                            <div className="d-flex flex-row">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => updateRoomCount("decrement")}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "solid 1px lightgray",
                                                                        width: "25px",
                                                                        height: "25px",
                                                                        textAlign: "center",
                                                                        fontWeight: "bold",
                                                                        alignSelf: "center",
                                                                    }}
                                                                >
                                                                    -
                                                                </button>
                                                                <span
                                                                    className='bg-white'
                                                                    style={{
                                                                        border: "solid 1px lightgray",
                                                                        width: "50px",
                                                                        textAlign: "center",
                                                                        fontWeight: "bold",
                                                                        alignSelf: "center",
                                                                    }}
                                                                >
                                                                    {rooms?.length}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => updateRoomCount("increment")}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "solid 1px lightgray",
                                                                        width: "25px",
                                                                        height: "25px",
                                                                        textAlign: "center",
                                                                        fontWeight: "bold",
                                                                        alignSelf: "center",
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex flex-column">
                                                        {rooms.map((room) => (
                                                            <div
                                                                key={room.id}
                                                                className="d-flex flex-row bg-white"
                                                                style={{
                                                                    border: "solid 1px lightgray",
                                                                    padding: "10px",
                                                                    width: "100%",
                                                                    marginBottom: "20px",
                                                                }}
                                                            >
                                                                <div
                                                                    className="d-flex flex-row"
                                                                    style={{ justifyContent: "space-between", width: "100%", gap: '3px' }}
                                                                >
                                                                    <div
                                                                        className="d-flex flex-column"
                                                                        style={{ textAlign: "center" }}
                                                                    >
                                                                        <label htmlFor="">Adult</label>
                                                                        <div
                                                                            className="d-flex flex-row"
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    updateRoomCounters(
                                                                                        room.id,
                                                                                        "adult",
                                                                                        "decrement"
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    border: "solid 1px lightgray",
                                                                                    width: "25px",
                                                                                    height: "25px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "bold",
                                                                                    alignSelf: "center",
                                                                                }}
                                                                            >
                                                                                -
                                                                            </button>
                                                                            <span
                                                                                style={{
                                                                                    border: "solid 1px lightgray",
                                                                                    width: "50px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "bold",
                                                                                    alignSelf: "center",
                                                                                }}
                                                                            >
                                                                                {room.adultCounter}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    updateRoomCounters(
                                                                                        room.id,
                                                                                        "adult",
                                                                                        "increment"
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    border: "solid 1px lightgray",
                                                                                    width: "25px",
                                                                                    height: "25px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "bold",
                                                                                    alignSelf: "center",
                                                                                }}
                                                                            >
                                                                                +
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="d-flex flex-column"
                                                                        style={{
                                                                            textAlign: "center",
                                                                            marginRight: "30px",
                                                                        }}
                                                                    >
                                                                        <label htmlFor="">Children</label>
                                                                        <div
                                                                            className="d-flex flex-row"
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    updateRoomCounters(
                                                                                        room.id,
                                                                                        "child",
                                                                                        "decrement"
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    border: "solid 1px lightgray",
                                                                                    width: "25px",
                                                                                    height: "25px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "bold",
                                                                                    alignSelf: "center",
                                                                                }}
                                                                            >
                                                                                -
                                                                            </button>
                                                                            <span
                                                                                style={{
                                                                                    border: "solid 1px lightgray",
                                                                                    width: "50px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "bold",
                                                                                    alignSelf: "center",
                                                                                }}
                                                                            >
                                                                                {room.childCounter}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    updateRoomCounters(
                                                                                        room.id,
                                                                                        "child",
                                                                                        "increment"
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    border: "solid 1px lightgray",
                                                                                    width: "25px",
                                                                                    height: "25px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "bold",
                                                                                    alignSelf: "center",
                                                                                }}
                                                                            >
                                                                                +
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="d-flex flex-column"
                                                                    style={{ width: "30%", gap: "10px" }}
                                                                >
                                                                    {room.childrenAges.map((child, index) => (
                                                                        <div
                                                                            className="d-flex flex-column"
                                                                            style={{ margin: "auto" }}
                                                                            key={index}
                                                                        >
                                                                            <label>{index + 1} Age:</label>
                                                                            <input
                                                                                type="number"
                                                                                value={child.age || ""}
                                                                                style={{
                                                                                    width: "50px",
                                                                                    border: "solid 1px lightgray",
                                                                                    padding: "1%",
                                                                                    borderRadius: "10px",
                                                                                }}
                                                                                name="children_age[]"
                                                                                required
                                                                                onChange={(e) =>
                                                                                    handleChildAgeChange(
                                                                                        room.id,
                                                                                        index,
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-item dropdown">
                                                <label className="form-label fs-14 text-default mb-3">Nationality</label>
                                                <Select
                                                    options={countries} // Ülkeler listesi
                                                    values={nation ? [{ name: nation }] : []}
                                                    onChange={handleChange} // Değer değişim işlemi
                                                    valueField="name" // Veri alanı
                                                    labelField="name" // Görünür alan
                                                    searchable={true} // Arama özelliği
                                                    placeholder="Select nation" // Placeholder metni
                                                    dropdownHeight="200px" // Açılır menü yüksekliği
                                                    closeOnSelect={true} // Seçimden sonra menüyü kapat
                                                    multi={false} // Tek seçim modu
                                                    className="custom-dropdown"
                                                    style={{ borderRadius: '10px', borderColor: 'whitesmoke' }}
                                                />
                                            </div>
                                        </div>
                                        <button type="submit"
                                            className="btn btn-dark search-btn rounded">Search</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>


                    <div className="row d-flex flex-column-reverse flex-xl-row">
                        <div className="col-xl-3 col-lg-3 theiaStickySidebar">
                            <div style={{ height: '150px', position: 'relative' }}>
                                <a style={{ textDecoration: 'none' }} onClick={handleClickMap}>
                                    <GoogleMapsLoader apiKey={apiKey}>
                                        <StaticGoogleMap apiKey={apiKey} markers={markers} />
                                    </GoogleMapsLoader>
                                    <button
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            backgroundColor: '#007bff',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        View Map
                                    </button>
                                </a>

                            </div>

                            <div className="card filter-sidebar mb-lg-0 mb-4">
                                <div className="card-body p-0">
                                    <form >
                                        <div className="accordion accordion-list">

                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-popular_p" aria-expanded="true"
                                                        aria-controls="accordion-popular" role="button">
                                                        <i className="isax isax-coin text-primary me-2"></i>Price Range
                                                    </div>
                                                </div>
                                                <div id="accordion-popular_p" className="accordion-collapse show collapse">
                                                    <div className="accordion-body d-flex flex-row ">
                                                        <div style={{ paddingTop: "20px", width: "100%", margin: "0 auto" }}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                                                {/* Min ve Max değerleri başta ve sonda göster */}
                                                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>0 EUR</span>
                                                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>7500 EUR</span>
                                                            </div>
                                                            <RangeSlider
                                                                min={0}
                                                                max={7500}
                                                                value={[prices.min_price, prices.max_price]} // Fiyatları slider'a bağla
                                                                onInput={handleRangeChange} // Slider hareket ettikçe fiyatları güncelle
                                                                onThumbDragEnd={handleDragEnd} // Sürükleme bırakıldığında işlemi tetikle
                                                                thumbsDisabled={[false, false]}
                                                                rangeSlideDisabled={false}
                                                            />
                                                            <p style={{ textAlign: 'center' }} className='mt-4 mb-4'><span style={{ fontWeight: 'bold', fontSize: '14px' }}>{prices.min_price} EUR</span> - <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{prices.max_price} EUR</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-bottom p-3" >
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-brands" aria-expanded="true"
                                                        aria-controls="accordion-brands" role="button">
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>Star
                                                    </div>
                                                </div>
                                                <div id="accordion-brands" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                gap: "5px",
                                                            }}
                                                        >
                                                            {/* {[...Array(5)].map((_, index) => (
                                                        <FaStar
                                                            key={index}
                                                            className="star-icon"
                                                            style={{
                                                                color: index < selectedStars ? "orange" : "gray", // Gösterimi kontrol eder
                                                                fontSize: "24px",
                                                                cursor: "pointer",
                                                                transition: "color 0.3s ease",
                                                            }}
                                                            onClick={() => handleStarClick(index)} // Doğru seçimi sağlar
                                                        />
                                                    ))} */}

                                                            <div className="d-flex flex-row gap-1">
                                                                {[1, 2, 3, 4, 5].map((star) => (
                                                                    <div
                                                                        key={star}
                                                                        className="d-flex flex-row gap-1"
                                                                        style={{
                                                                            border: "solid",
                                                                            borderRadius: "8px",
                                                                            margin: "2px",
                                                                            padding: "5px",
                                                                            justifyContent: "center",
                                                                            textAlign: "center",
                                                                            alignContent: "center",
                                                                            backgroundColor: selectedStar === star ? "darkgray" : "white",
                                                                            borderColor: "darkgray",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() => handleStarClick(star)}
                                                                        onMouseEnter={(e) =>
                                                                            (e.currentTarget.style.backgroundColor = "lightgray")
                                                                        }
                                                                        onMouseLeave={(e) =>
                                                                        (e.currentTarget.style.backgroundColor =
                                                                            selectedStar === star ? "darkgray" : "white")
                                                                        }
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                color: selectedStar === star ? "white" : "darkgray",
                                                                            }}
                                                                        >
                                                                            {star}
                                                                        </span>
                                                                        <FaStar
                                                                            style={{
                                                                                margin: "auto",
                                                                                color: selectedStar === star ? "white" : "darkgray",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div
                                                        className="accordion-button p-0"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-accommodation"
                                                        aria-expanded="true"
                                                        aria-controls="accordion-accommodation"
                                                        role="button"
                                                    >
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>
                                                        Accommodation Types
                                                    </div>
                                                </div>
                                                <div id="accordion-accommodation" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(accommodationLess ? accommodation.slice(0, 5) : accommodation).map((item, index) => (
                                                            <div
                                                                key={`accommodation-${index}`}
                                                                className="form-check d-flex align-items-center mb-2 ps-0"
                                                            >
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    name="accommodation"
                                                                    type="checkbox"
                                                                    id={`accommodation-${index}`}
                                                                    value={item.code}
                                                                    checked={selectedAccommodations.includes(item.code)}
                                                                    onChange={() => handleAccomChange(item.code)}
                                                                />

                                                                <label
                                                                    className="form-check-label ms-2"
                                                                    htmlFor={`accommodation-${index}`}
                                                                >
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">
                                                                            {item.typeDescription}
                                                                        </span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        <div className="mt-3">
                                                            <a
                                                                className="btn btn-link p-0 text-primary"
                                                                onClick={() => setAccommodationLess((prev) => !prev)}
                                                            >
                                                                {accommodationLess ? "See More" : "See Less"}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div
                                                        className="accordion-button p-0"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-chains"
                                                        aria-expanded="true"
                                                        aria-controls="accordion-chains"
                                                        role="button"
                                                    >
                                                        <FaHotel className="text-primary me-2"/>
                                                        Chains
                                                    </div>
                                                </div>
                                                <div id="accordion-chains" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(chainLess ? chains.slice(0, 5) : chains).map((item, index) => (
                                                            <div
                                                                key={`chain-${index}`}
                                                                className="form-check d-flex align-items-center mb-2 ps-0"
                                                            >
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    name="chain"
                                                                    type="checkbox"
                                                                    style={{
                                                                        border: 'solid gray',
                                                                        borderRadius: '4px',
                                                                        width: '17px',
                                                                        height: '17px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    id={`chain-${index}`}
                                                                    value={item.code}
                                                                    checked={selectedChain.code === item.code}
                                                                    onChange={() => handleChainChange(item.code, item.name)}
                                                                />
                                                                <label
                                                                    className="form-check-label ms-2"
                                                                    htmlFor={`chain-${index}`}
                                                                >
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">{item.name}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        {chains.length > 5 && (
                                                            <div className="mt-3">
                                                                <button
                                                                    className="btn btn-link p-0 text-primary"
                                                                    onClick={(event) => {
                                                                        event.preventDefault();
                                                                        setChainLess((prev) => !prev);
                                                                    }}
                                                                >
                                                                    {chainLess ? "See More" : "See Less"}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div
                                                        className="accordion-button p-0"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-neighborhood"
                                                        aria-expanded="true"
                                                        aria-controls="accordion-neighborhood"
                                                        role="button"
                                                    >
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>
                                                        Neighborhood
                                                    </div>
                                                </div>
                                                <div id="accordion-neighborhood" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(neighborhoodLess ? neighborhoods.slice(0, 5) : neighborhoods).map((item, index) => (
                                                            <div
                                                                key={`neighborhood-${index}`}
                                                                className="form-check d-flex align-items-center mb-2 ps-0"
                                                            >
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    name="neighborhood"
                                                                    type="radio"
                                                                    style={{
                                                                        border: 'solid gray',
                                                                        borderRadius: '4px',
                                                                        width: '17px',
                                                                        height: '17px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    id={`neighborhood-${index}`}
                                                                    value={item.name}
                                                                    checked={selectedNeighborhood.name === item.name}
                                                                    onChange={() => handleNeighborhoodChange(item.name)}
                                                                />
                                                                <label
                                                                    className="form-check-label ms-2"
                                                                    htmlFor={`neighborhood-${index}`}
                                                                >
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">{item.name}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        <div className="mt-3">
                                                            <button
                                                                className="btn btn-link p-0 text-primary"
                                                                onClick={(event) => {
                                                                    event.preventDefault();
                                                                    setNeighborhoodLess((prev) => !prev);
                                                                }}
                                                            >
                                                                {neighborhoodLess ? "See More" : "See Less"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div
                                                        className="accordion-button p-0"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-popular-location"
                                                        aria-expanded="true"
                                                        aria-controls="accordion-popular-location"
                                                        role="button"
                                                    >
                                                        <i className="isax isax-location text-primary me-2"></i>
                                                        Popular Locations
                                                    </div>
                                                </div>
                                                <div id="accordion-popular-location" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(popularLocationLess ? popularLocations.slice(0, 5) : popularLocations).map((item, index) => (
                                                            <div
                                                                key={`popular-location-${index}`}
                                                                className="form-check d-flex align-items-center mb-2 ps-0"
                                                            >
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    name="popularLocation"
                                                                    type="radio"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    id={`popular-location-${index}`}
                                                                    value={item.name}
                                                                    checked={selectedPopularLocation.name === item.name}
                                                                    onChange={() => handlePopularLocationChange(item.name)}
                                                                />
                                                                <label
                                                                    className="form-check-label ms-2"
                                                                    htmlFor={`popular-location-${index}`}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">{item.name}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        <div className="mt-3">
                                                            <a
                                                                className="btn btn-link p-0 text-primary"
                                                                onClick={(event) => {
                                                                    setPopularLocationLess((prev) => !prev); // State'i değiştir
                                                                }}
                                                            >
                                                                {popularLocationLess ? "See More" : "See Less"}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div
                                                        className="accordion-button p-0"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-board"
                                                        aria-expanded="true"
                                                        aria-controls="accordion-board"
                                                        role="button"
                                                    >
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>
                                                        Boards
                                                    </div>
                                                </div>
                                                <div id="accordion-board" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {boards.map((board, index) => (
                                                            <div
                                                                key={`board-${index}`}
                                                                className="form-check d-flex align-items-center mb-2 ps-0"
                                                            >
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    name="board"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    type="checkbox"
                                                                    id={`board-${index}`}
                                                                    value={board.code}
                                                                    checked={selectedBoards.includes(board.code)}
                                                                    onChange={() => handleBoardChange(board.code)}
                                                                />
                                                                <label
                                                                    className="form-check-label ms-2 "
                                                                    htmlFor={`board-${index}`}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">{board.name.toLocaleLowerCase()}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>



                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-9 col-lg-9">
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <p className="mb-3">
                                    <a onClick={handleClickMap} style={{ color: 'blue' }}>Click </a>
                                    for map view
                                </p>
                                <div className="d-flex align-items-center flex-wrap">
                                    <div className="dropdown mb-3">
                                        <a href="javascript:void(0);" className="dropdown-toggle py-2" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="fw-medium text-gray-9">Sort By : </span>{selectedOption.label ?? 'Default'}
                                        </a>
                                        <div className="dropdown-menu dropdown-sm">
                                            <h6 className="fw-medium fs-16 mb-3">Sort By</h6>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="recommend"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="checkbox"
                                                    id="recommend"
                                                    checked={selectedOption.id === 'recommend'}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="recommend">Recommend</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="recommend"
                                                    type="checkbox"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    id="price_asc"
                                                    checked={selectedOption.id === 'price_asc'}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="price_asc">Price: low to high</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="recommend"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="checkbox"
                                                    id="price_desc"
                                                    checked={selectedOption.id === 'price_desc'}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="price_desc">Price: high to low</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="recommend"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="checkbox"
                                                    id="name_asc"
                                                    checked={selectedOption.id === 'name_asc'}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="name_asc">Name A-Z</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="recommend"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="checkbox"
                                                    id="name_desc"
                                                    checked={selectedOption.id === 'name_desc'}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="name_desc">Name Z-A</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="hotel-list">
                                <div className="row justify-content-center">

                                    <div className="col-md-12">
                                        {
                                            firstHotel?.[0] != null &&
                                            <ListCard
                                                isFirstHotel={true}
                                                hotel={firstHotel?.[0]}
                                                handleViewDetails={handleViewDetails}
                                                handleBookSubmit={handleBookSubmit}
                                                setSelectedRate={setSelectedRate}
                                            />
                                        }
                                        {
                                            Hotels.length > 0 ? (
                                                <>
                                                    {Hotels.map((hotel, index) => {
                                                        // Eğer firstHotel.code ile hotel.code eşleşiyorsa bu döngüyü atla
                                                        if (firstHotel?.[0]?.code === hotel.code) {
                                                            return null;
                                                        }

                                                        return (
                                                            <>
                                                                {(selectedStar != null && hotel.categoryCode?.[0] != selectedStar) ? (
                                                                    <></>
                                                                ) : (
                                                                    <ListCard
                                                                        index={index}
                                                                        isFirstHotel={false}
                                                                        hotel={hotel}
                                                                        handleViewDetails={handleViewDetails}
                                                                        handleBookSubmit={handleBookSubmit}
                                                                        setSelectedRate={setSelectedRate}
                                                                    />
                                                                )}
                                                            </>
                                                        );
                                                    })}

                                                    {moreStatu ? (
                                                        <div className="d-flex">
                                                            <p style={{ margin: 'auto' }}>Loading data, please wait...</p>
                                                        </div>
                                                    ) : moreButtonStatu ? (
                                                        <div className="d-flex">
                                                            <button
                                                                type="button"
                                                                style={{ margin: 'auto' }}
                                                                className="btn btn-primary"
                                                                onClick={handleLoadMore}
                                                                disabled={moreStatu}
                                                            >
                                                                Show more hotels
                                                            </button>
                                                        </div>
                                                    ) : null}
                                                </>
                                            ) : (
                                                <div className="flex items-center justify-center" style={{ marginBlock: '100px' }}>
                                                    <p className="text-center">No data in hotels</p>
                                                </div>
                                            )
                                        }

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <Modal
                show={selectedRate !== null}
                onHide={() => setSelectedRate(null)}
                centered
                backdropClassName="custom-backdrop" // Arka planın karartmasını özelleştirmek için
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cancellation Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRate?.cancellationPolicies?.map((policy, index) => (
                        <div key={index} className="d-flex flex-column" style={{ minWidth: "200px" }}>
                            <p
                                className="d-inline-flex align-items-center mb-2 me-2 gap-1"
                                style={{ color: "black", textAlign: "center", fontSize: "13px" }}
                            >

                                {
                                    // Markup kullanmadan doğrudan fiyat karşılaştırması yapıyoruz
                                    Number(selectedRate?.cancellationPolicies?.[0]?.amount).toFixed(2) === Number(selectedRate.net).toFixed(2) ?
                                        <>
                                            <div className="d-flex flex-row align-items-center gap-2">
                                                <TiTick style={{ color: "green", fontSize: "20px" }} />
                                                <p className="mb-0 text-black">Free Cancellation until {new Intl.DateTimeFormat("en-US", {
                                                    dateStyle: "medium",
                                                    timeStyle: "short",
                                                }).format(new Date(selectedRate?.cancellationPolicies?.[0]?.from))}</p>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <span>You can cancel until </span>
                        <span style={{ color: "red" }}>
                            {new Intl.DateTimeFormat("en-US", {
                                dateStyle: "medium",
                                timeStyle: "short",
                            }).format(new Date(policy.from))}
                        </span>
                        
                        <span> for </span>
                        <span style={{ color: "red" }}>
                            ${Number(policy.amount).toFixed(2)}
                        </span>

                                        </>

                                }
                            </p>
                        </div>
                    ))}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setSelectedRate(null)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Layout>
    )
}
const neighborhoods =
    [
        { "name": "Beşiktaş", "lat": 41.0591837, "lng": 29.0077341 },
        { "name": "Galata", "lat": 41.0282579, "lng": 28.9816244 },
        { "name": "Şişli", "lat": 41.0639608, "lng": 28.9878019 },
        { "name": "Taksim", "lat": 41.0362673, "lng": 28.9838089 },
        { "name": "Beyoğlu", "lat": 41.0289381, "lng": 28.9721545 },
        { "name": "Sirkeci", "lat": 41.0144465, "lng": 28.9728756 },
        { "name": "Nişantaşı", "lat": 41.0503098, "lng": 28.9886143 },
        { "name": "Fatih", "lat": 41.0098076, "lng": 28.9550328 },
        { "name": "Sultanahmet", "lat": 41.0087436, "lng": 28.9762436 },
        { "name": "Kadıköy", "lat": 40.983891, "lng": 29.024940 },
        { "name": "YeniKapi Station", "lat": 41.0061096, "lng": 28.9545701 },
        { "name": "Istanbul (IST)", "lat": 41.0362673, "lng": 28.9838089 },
        { "name": "Istanbul City Center", "lat": 41.0362673, "lng": 28.9838089 },
        { "name": "Laleli", "lat": 41.0098076, "lng": 28.9550328 },
        { "name": "Ataşehir", "lat": 41.0005706, "lng": 29.1340969 },
        { "name": "Beylikdüzü", "lat": 41.0064064, "lng": 28.662227 },
        { "name": "Karaköy", "lat": 41.0247697, "lng": 28.9775374 },
        { "name": "Bakırköy", "lat": 40.9797332, "lng": 28.8841949 },
        { "name": "Istanbul", "lat": 41.0087436, "lng": 28.973674 }
    ];
const popularLocations =
    [
        { "name": "Hagia Sophia", "lat": 41.0087436, "lng": 28.9762436 },
        { "name": "Taksim Square", "lat": 41.0362673, "lng": 28.9838089 },
        { "name": "Sultanahmet", "lat": 41.0087436, "lng": 28.9762436 },
        { "name": "Bosphorus", "lat": 41.04752, "lng": 29.0220014 },
        { "name": "Grand Bazaar", "lat": 41.007783, "lng": 28.96308 },
        { "name": "Galata Tower", "lat": 41.0304097, "lng": 28.9743 },
        { "name": "Istiklal Avenue", "lat": 41.0360515, "lng": 28.982556 },
        { "name": "Blue Mosque", "lat": 41.0087436, "lng": 28.973674 },
        { "name": "Mall of Istanbul", "lat": 41.063751, "lng": 28.8019724 },
        { "name": "Galataport", "lat": 41.0262749, "lng": 28.9761556 },
        { "name": "Kadıköy Port", "lat": 40.988424, "lng": 29.018506 },
        { "name": "Tüyap Fair Convention and Congress Center", "lat": 41.0230047, "lng": 28.6240065 },
        { "name": "Bağdat Avenue", "lat": 40.9683161, "lng": 29.062608 },
        { "name": "Florya Beach", "lat": 40.988953, "lng": 28.7888054 },
        { "name": "Fatih Mosque", "lat": 41.0120277, "lng": 28.9523559 },
        { "name": "Ataköy Marina", "lat": 40.9778051, "lng": 28.8675519 },
        { "name": "Pera Palace Hotel", "lat": 41.0310396, "lng": 28.970909 },
        { "name": "Ciragan Palace", "lat": 41.0439752, "lng": 29.0135737 },
        { "name": "Bahçeşehir Gölet Park", "lat": 41.0565169, "lng": 28.6621474 },
        { "name": "Ataturk Olympic Stadium", "lat": 41.063751, "lng": 28.8019724 },
    ];
const boards = [
    { id: 1, code: "BB", name: "BED AND BREAKFAST" },
    { id: 3, code: "FB", name: "FULL BOARD" },
    { id: 2, code: "HB", name: "HALF BOARD" },
    { id: 5, code: "RO", name: "ROOM ONLY" },
];


